/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ depth: NonNullable<unknown> }} Documents_DepthInputs */

const cs_documents_depth = /** @type {(inputs: Documents_DepthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Úroveň ${i?.depth}`)
};

const en_documents_depth = /** @type {(inputs: Documents_DepthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Level ${i?.depth}`)
};

/**
* | output |
* | --- |
* | "Level {depth}" |
*
* @param {Documents_DepthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_depth = /** @type {((inputs: Documents_DepthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_DepthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_depth(inputs)
	return cs_documents_depth(inputs)
});